//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import staffinfo from "@/pcpage/hr/recruitment/resumeApply/staffInfo"
import AttachLoad from "@/pccomponents/AttachLoad";
import educationinfo from "@/pcpage/hr/recruitment/resumeApply/educationinfo"
import companyinfo from "@/pcpage/hr/recruitment/resumeApply/companyinfo"
import governmentExaminfo from "@/pcpage/hr/recruitment/resumeApply/governmentExaminfo"
import affiliationsinfo from "@/pcpage/hr/recruitment/resumeApply/affiliationsinfo"
import declarationinfo from "@/pcpage/hr/recruitment/resumeApply/declarationinfo"
import eassyinfo from "@/pcpage/hr/recruitment/resumeApply/eassyinfo"
import confiminfo from "@/pcpage/hr/recruitment/resumeApply/confimInfo"
import commonload from "@/pcpage/hr/common/commonload";
import formValidate from "@/js/formValidate";
export default {
    extends : commonload,
    name: "resumeload",
    components:{
      staffinfo,
      educationinfo,
      companyinfo,
      governmentExaminfo,
      affiliationsinfo,
      declarationinfo,
      AttachLoad,
      eassyinfo,
      confiminfo
    },
    data(){
      return {
        checkArr:[],
        ifcheck:false,
        dialogVisible:false,
        keyname : "formid",
        //进入公司来源标志，控制后面文本框显示
        infoflag :"",
        //外网下拉框获取选项
        apiUrl: "onboarding/getSelectOption",
        //进入公司来源
        infosourceList:[],
        //岗位列表
        positionList:[],
        config: {
          btype: "RESUME",
          //图片
          tagname: "resumeinfofile",
          //居住地图附件
          tagnamemap: "resumeinfofile",

          tabname: "bresumeinfo",

          ifshowtip:false,
          docutypeid:"",
          totalnum:2000,
          isEdit:true,
        },
        nosession:true,
        record: {
          rowList: [], //行表信息
          delrowids: [], //传给后端的删除行id，从逗号分隔的字符串，改为数组，
          rowmodel :{}, //单据行项模版
          infopath:[],
          peraddress:{
            addrtype:[]
          },
          curraddress:{
            addrtype:[]
          }
        },
         validFormInfo: { //表单校验对象信息
          title:"Application Form",
          mainFormName: "record",
          childComponentName: [
            {
              title:"Basic Information",
              componentname:"baseinfoForm"
            },
            {
              title:"Education",
              componentname:"educationinfo"
            },
            {
              title:"Work Experience",
              componentname:"companyinfo"
            },
            {
              title:"Essay",
              componentname:"eassyinfo"
            },
            {
              title:"Declaration",
              componentname:"declarationinfo"
            },
          ]
        },

      }
    },
    methods:{
       //页面初始化
      async init(){
        this.initParam();
        this.initSelect();
      },
       /**
         * 初始化参数
         */
        initParam(){
            this.loadAddAction = "api/api/loadAddResume";
            this.saveAction="api/api/saveresume";
            this.deleteAction = "recruitpost/delete";
            this.loadAction = "api/api/loadresume";
            this.currRouterPath="/recruit/resumeload";
            this.fileidname = ['fileids'];
        },
         /**
         * 行项下拉框初始化
         */
        async initSelect(){
            //初始化下拉框、多选框、单选框
            let requestJsonData = []; 
            let infosource = {
              showcode:'infosourceList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:true,
              paras:{"paras0":"ONLINE","paras1":"1"}
            };
            let position = { 
              showcode:'positionList',
              selectcode:'SYS_CDFRECRUITPOSITION',
              hasnull:true,
              paras:{"paras0":"","paras1":"1"}
            }
            requestJsonData.push(infosource);
            requestJsonData.push(position);
            this.initDropDownWithUrl(this,requestJsonData,this.apiUrl);
        },
      /**
       * 切换了解公司信息来源
       */
      checkChange(e){ //申请表格单选
        this.record.infopath = [];
        let infopath = "";
        if(this.record.infopath.length >0){
            infopath = this.record.infopath[0];
        }
        this.record.infopath.push(e);
        if(this.infoflag !=e ){
            this.$set(this.record,"infopathdesc","");
            this.$set(this.record,"infosource","");

        }
        this.infoflag = e;
      },
      checkAgree(){
        if(this.checkArr[0] == '1'){
          this.ifcheck = true;
        }else{
          this.ifcheck = false;
        }
      },
      /**
       * 页面加载前
       */
      async doLoadRecordBefore(oQuery, data){
        let appkey = this.$route.query.appkey;
        oQuery.appkey = appkey;
      },
       /**
         * 公用单据加载方法(执行后调用方式)
         * oQuery : 后端交互请求参数对象
         * data ：后端返回数据
         */
        async doLoadRecordAfter(oQuery, data) {
          //重新赋值附件的ID
          let t_record = oQuery.record;
          if(this.fileidname && this.fileidname.length >0){
            for(var i = 0  ; i < this.fileidname.length; i++){
                let attr  = this.fileidname[i];
                if(t_record && t_record[attr] && t_record[attr] != ''){
                  this.$set(this.record,attr,t_record[attr]);
                }
            }
          }
          this.infoflag = this.record.infoflag;
          this.$set(this.record,"notNullItems",this.notNullItems);
          //获取选中的岗位信息
          //判断是否已经保存过了
          if(this.$route.query.formid && this.$route.query.formid!=''){
            this.$set(this.config,"isEdit",false);

          }
          await formValidate.bindRules4NotFlow(this,"submit");

        },
        async submitFormbill(){
          //this.saveorsubmitBynoSession("submit");
          this.formTipArray.length=0;
          await formValidate.bindRules4NotFlow(this,"submit");
          let flag =await this.validateBynosession(this,this.validFormInfo);
          if(flag === true){
            let flag1 = await this.checkEmailCode();
            if(flag1 === true){
              this.dialogVisible = true;
            }
          }
        },
        async closeDialog(){

        },
        async checkEmailCode(){
           let returnflag = true;
           let url = "api/api/checkEmailCode";
           let params = {
              email: this.record.email,
              validcode: this.record.validcode
            };
          await this.axios.post(url, params).then(({ data }) => {
              let json = data.data;
              let code = json.code;
              let msg = json.msg;
              if(code === "1"){
                  returnflag = true;
              }else{
                  this.tipError(msg);  
                  returnflag = false;                  
              }

          });
          return returnflag;
        },
        /**
        * 校验教育开始和结束日期
        */
        async checktimebucket(){
          var len = this.record.education.length;
          var flag = true;
          for(let i = 0 ; i < len; i++ ){
            if(this.record.education[i].begindate !=null && this.record.education[i].begindate != ''
              && this.record.education[i].enddate !=null && this.record.education[i].enddate != ''){
                  let begintime = this.forMatDate(this.record.education[i].begindate);
                  let endtime = this.forMatDate(this.record.education[i].enddate);
                  if (begintime > endtime) {
                    flag = false;
                    return false;
                  }
            }
          }
          for(let i = 0 ; i < len; i++ ){
            let begintime = this.record.education[i].begindate;
            let endtime = this.record.education[i].enddate;
          //只有时间段不为空的时候才进行比较
          if(typeof(begintime)=="undefined" || typeof(endtime)=="undefined" || !this.isNotNullOrEmpty(begintime) || !this.isNotNullOrEmpty(endtime) ){
                  continue;
            }
            console.log('2020年06月22日17:35:44 staffentrycontractinfo.vue[描述]——[begintime] :',begintime);
            var begintimes = begintime.split("-");
            //格式化开始时间
            let s_begintime = new Date(begintimes[2], begintimes[1], begintimes[0]);
            
            var endtimes = endtime.split("-");
            //格式化结束时间
            let s_endtime = new Date(endtimes[2], endtimes[1], endtimes[0]);
            
            for(let j = 0 ;j < len; j++){
                let v_begintime = this.record.education[j].begindate;
                let v_endtime = this.record.education[j].enddate;
                //不和当前行项比较，如果开始时间或者结束时间为空的话也不进行比较
                if(j === i || typeof(begintime)=="undefined" || typeof(endtime)=="undefined" || !this.isNotNullOrEmpty(begintime) || !this.isNotNullOrEmpty(endtime) || v_begintime === '' || v_endtime==='' || !this.isNotNullOrEmpty(v_begintime) || !this.isNotNullOrEmpty(v_endtime)){
                    continue;
                }

                var v_begintimes = v_begintime.split("-");
                //格式化开始时间
                let sv_begintime = new Date(v_begintimes[2], v_begintimes[1], v_begintimes[0]);
                
                var v_endtimes = v_endtime.split("-");
                //格式化结束时间
                let sv_endtime = new Date(v_endtimes[2], v_endtimes[1], v_endtimes[0]);
                if((s_begintime >= sv_begintime && s_begintime <= sv_endtime) || (s_endtime >= sv_begintime && s_endtime <= v_endtimes)){
                  return false;
                }

            }
          }
          return true;
        },
        /**
        * 校验工作开始和结束日期
        */
        async checktimework(){
          var len = this.record.resumerow.length;
          var flag = true;
          for(let i = 0 ; i < len; i++ ){
            if(this.record.resumerow[i].begindate !=null && this.record.resumerow[i].begindate != ''
              && this.record.resumerow[i].enddate !=null && this.record.resumerow[i].enddate != ''){
                  let begintime = this.forMatDate(this.record.resumerow[i].begindate);
                  let endtime = this.forMatDate(this.record.resumerow[i].enddate);
                  if (begintime > endtime) {
                    flag = false;
                    return false;
                  }
            }
          }
          for(let i = 0 ; i < len; i++ ){
            let begintime = this.record.resumerow[i].begindate;
            let endtime = this.record.resumerow[i].enddate;
          //只有时间段不为空的时候才进行比较
          if(typeof(begintime)=="undefined" || typeof(endtime)=="undefined" || !this.isNotNullOrEmpty(begintime) || !this.isNotNullOrEmpty(endtime) ){
                  continue;
            }
            console.log('2020年06月22日17:35:44 staffentrycontractinfo.vue[描述]——[begintime] :',begintime);
            var begintimes = begintime.split("-");
            //格式化开始时间
            let s_begintime = new Date(begintimes[2], begintimes[1], begintimes[0]);
            
            var endtimes = endtime.split("-");
            //格式化结束时间
            let s_endtime = new Date(endtimes[2], endtimes[1], endtimes[0]);
            
            for(let j = 0 ;j < len; j++){
                let v_begintime = this.record.resumerow[j].begindate;
                let v_endtime = this.record.resumerow[j].enddate;
                //不和当前行项比较，如果开始时间或者结束时间为空的话也不进行比较
                if(j === i || typeof(begintime)=="undefined" || typeof(endtime)=="undefined" || !this.isNotNullOrEmpty(begintime) || !this.isNotNullOrEmpty(endtime) || v_begintime === '' || v_endtime==='' || !this.isNotNullOrEmpty(v_begintime) || !this.isNotNullOrEmpty(v_endtime)){
                    continue;
                }

                var v_begintimes = v_begintime.split("-");
                //格式化开始时间
                let sv_begintime = new Date(v_begintimes[2], v_begintimes[1], v_begintimes[0]);
                
                var v_endtimes = v_endtime.split("-");
                //格式化结束时间
                let sv_endtime = new Date(v_endtimes[2], v_endtimes[1], v_endtimes[0]);
                if((s_begintime >= sv_begintime && s_begintime <= sv_endtime) || (s_endtime >= sv_begintime && s_endtime <= v_endtimes)){
                  return false;
                }

            }
          }
          return true;
        },
        /**
        * 校验手机号位数
        */
        async valiMobileNumCount(){
          var number = this.record.mobile
          var l = number.length;
          if(l == 11){
            return true;
          }else {
            return false;
          }
        },
        /**
        * 校验座机号码位数
        */
        async valiLandlineNumCount(){
          var number = this.record.landlinenumber
          if(number==undefined || number==''){
            return true
          }
          if(number!=undefined && number!=null){
            var l = number.length;
            if(l == 8){
              return true;
            }else {
              return false;
            }
          }
        },
    },
    created() {
      /**
       * 页面渲染后初始化数据
       */
      this.init().then(() => { 
        this.doLoadRecordNot4Flow();
      });
    }

}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/resumeload.vue